export const ENDPOINT = {
    LOGIN: "auth/login",
    RESET_PASSWORD: "lender/setPassword",

    /* CHANGE PASSWORD */
    CHANGE_PASSWORD: "auth/changePassword"
};
